module.exports = __webpack_public_path__ + "img/店铺数据ico.931fcc64.png";